export default {
  text: {
    en: 'No events within selected filters',
  },
  reset: {
    en: 'Reset all',
  },
}
